import axios from 'axios';

import {
  CategoryGetRequest,
  CategoryGetResponse,
  CategoryListGetResponse,
  CategoryParams,
  CategoryPostRequest,
  CategoryPostResponse,
  CategoryPutRequest,
  CategoryPutResponse,
} from '../model/categoryModel';
import { ArticleParams } from '../../article/model/articleModel';

export const CategoryApi = {
  post: (data: CategoryPostRequest) => {
    return axios.post<CategoryPostResponse>('/api/categories', data);
  },
  put: (params: CategoryParams, data: CategoryPutRequest) => {
    return axios.put<CategoryPutResponse>(`/api/categories/${params.id}`, data);
  },
  delete: (params: ArticleParams, data: any) => {
    return axios.delete(`/api/categories/${params.id}`, data);
  },
  getOne: (params: CategoryParams) => {
    return axios.get<CategoryGetResponse>(`/api/categories/${params.id}`);
  },
  getAll: (params: CategoryGetRequest) => {
    return axios.get<CategoryGetResponse[]>('/api/categories', {
      params: params,
    });
  },
  getList: (params: CategoryGetRequest) => {
    return axios.get<CategoryListGetResponse[]>('/api/categories/select', {
      params: params,
    });
  },
  getCategoriesTree: (params: CategoryParams) => {
    return axios.get<CategoryGetResponse[]>(`/api/categories/${params.id}/tree`);
  },
};
